/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdCollapseProps, TdCollapsePanelProps } from './type';

export const collapseDefaultProps: TdCollapseProps = {
  defaultExpandAll: false,
  expandIcon: true,
  expandMutex: false,
  theme: 'default',
  defaultValue: [],
};

export const collapsePanelDefaultProps: TdCollapsePanelProps = {
  destroyOnCollapse: false,
  disabled: undefined,
  expandIcon: undefined,
  placement: 'bottom',
};
